module.exports = "/_next/static/images/3844744871131872b68a2f7919651576-2-woman-working@1x.jpg.webp";